export const Tabs = {
	SURVEY_TEMPLATE: 'SURVEY_TEMPLATE',
	PEOPLE: 'PEOPLE',
	REPORT: 'REPORT',
};
